<template>
    <div id="masterMore">
        <my-header></my-header>
        <div class="main-container mainCon">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="我的待办" name="first"></el-tab-pane>
                <el-tab-pane label="我的已办" name="second"></el-tab-pane>
                <el-tab-pane label="我的消息" name="third"></el-tab-pane>
            </el-tabs>
            <div class="needDeal" v-show="activeName == 'first'">
                <ul class="needList">
                    <li v-for="(item,index) in watingDealList" :key="index" :class="[ index == 5 ? 'lastLi' : '']">
                        <h4>
                            <strong @click="toProgress(item,1)">{{ item.dealTitle }}</strong>
                            <el-button @click="toProgress(item,1)">查看详情</el-button>
                        </h4>
                        <p v-if="item.dealEndTime">
                            截止日期：<span>{{ item.dealEndTime }}</span>
                        </p>
                    </li>
                </ul>
                <el-pagination
                    background
                    layout="total,prev, pager, next"
                    @current-change="handleWatingCurChange"
                    :current-page.sync="watingPager.pageNumber"
                    :page-size="watingPager.pageSize"
                    :total="watingPager.total">
                </el-pagination>
            </div>
            <div class="needDeal" v-show="activeName == 'second'">
                <ul class="needList">
                    <li v-for="(item,index) in hadDealtList" :key="index" :class="[ index == 5 ? 'lastLi' : '']">
                        <h4>
                            <strong @click="toProgress(item,2)">{{ item.dealTitle }}</strong>
                            <el-button @click="toProgress(item,2)">查看详情</el-button>
                        </h4>
                        <p v-if="item.dealEndTime">
                            截止日期：<span>{{ item.dealEndTime }}</span>
                        </p>
                    </li>
                </ul>
                <el-pagination
                    background
                    layout="total,prev, pager, next"
                    @current-change="handleHadDealCurChange"
                    :current-page.sync="hadDealPager.pageNumber"
                    :page-size="hadDealPager.pageSize"
                    :total="hadDealPager.total">
                </el-pagination>
            </div>
            <div class="dealed" v-show="activeName == 'third'">
                <ul class="list">
                    <li v-for="(item,index) in messageList" :key="index" @click="showDialog(item)" :class="{ readed : item.readFlag}">
                        <h4 class="infoTitle">
                            <strong>{{ item.msgTitle }}</strong>
                        </h4>
                        <p v-if="item.createDate">
                            消息时间：<span>{{ item.createDate }}</span>
                        </p>
                    </li>
                </ul>
                <el-pagination
                    background
                    layout="total,prev, pager, next"
                    @current-change="handleMessageCurChange"
                    :current-page.sync="messagePager.pageNumber"
                    :page-size="messagePager.pageSize"
                    :total="messagePager.total">
                </el-pagination>
            </div>
        </div>

        <el-dialog
            class="infoDialog"
            title= '消息通知'
            :visible.sync="dialogVisible"
            width="30%">
            <p>{{ dialogTitle }}</p>
            <p>{{ dialogContent ? '详情：'+ dialogContent : ''}}  <el-button type="text" v-if="currentLi.msgType == 12"  @click="download">   点击下载中标通知书 ↓</el-button></p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
             </span>
        </el-dialog>
    </div>
</template>
<script>
    import MyHeader from './MasterHeader.vue'
    export default {
        name: 'masterMore',
        data() {
            return {
                dialogVisible: false,//是否显示弹出层
                dialogTitle: '',
                dialogContent: '',
                watingDealList: [],//我的待办
                watingPager: {
                    pageNumber: 1,//当前第几页
                    pageSize: 10,//每页显示条数
                    total: 0,//总条数
                },
                hadDealtList: [],//我的已办
                hadDealPager: {
                    pageNumber: 1,//当前第几页
                    pageSize: 10,//每页显示条数
                    total: 0,//总条数
                },
                messageList:[],//我的消息列表
                messagePager: {
                    pageNumber: 1,//当前第几页
                    pageSize: 10,//每页显示条数
                    total: 0,//总条数
                },
                currentLi: {//当前消息的第几条
                    msgType: '',
                    subRelatedId:''
                },
                activeName: 'first',
            }
        },
        components: {
            MyHeader
        },
        created(){
            this.activeName = this.$route.params.activeName;
            this.getCur();
        },
        watch: {
//            "$route": "getCur"
        },
        methods:{
            toProgress(val,entrance){
//                console.log(val)
                if(val.actionType == 202){//邀请函待办
                    this.$router.push('/master/replyInvite/'+val.relatedId+'/'+entrance)
                } else if(val.actionType == 217){//下载标书待办
                    this.$router.push('/master/downloadDoc/'+val.relatedId+'/'+entrance)
                } else {//回标待办
                    this.$router.push('/master/processManagement/'+val.relatedId);
                }
            },
            handleClick(tab, event) {
//                console.log(tab, event);
                this.activeName = tab.paneName;
                this.$router.push('/master/more/'+tab.paneName);
                this.getCur();
            },
            getCur(){
                if(this.activeName == 'first'){
                    this.getPageInfo(this.watingPager,2);//页面初始化时渲染第一页我的待办
                } else if( this.activeName == 'second'){
                    this.getPageInfo(this.hadDealPager,3);//页面初始化时渲染第一页我的已办
                } else {
                    this.getPageInfo(this.messagePager,1);//页面初始化时渲染第一页我的消息
                }
            },
            getPageInfo(obj,type){//获取当前列表显示项
                var _this = this;
              this.$root.postHttp('/v1/outerformflow/managementCenterList',{
                  "pageFlag": 1,
                  "pageNumber": obj.pageNumber,
                  "pageSize": obj.pageSize,
                  "resultType": type  // 更多类型 1消息 2待办 3已办
              },function (res) {
                  if(type == 1){
                      _this.messageList = res.data.data.records;
                      obj.total = res.data.data.total;
                  } else if(type == 2){
                      _this.watingDealList = res.data.data.records;
                      obj.total = res.data.data.total;
                  } else {
                      _this.hadDealtList = res.data.data.records;
                      obj.total = res.data.data.total;
                  }
              })
            },
            handleWatingCurChange(val) {
//                console.log(`当前页: ${val}`);
                this.watingPager.pageNumber = val;
                this.getPageInfo(this.watingPager,2);//页面初始化时渲染第一页我的待办
            },
            handleHadDealCurChange(val) {
                this.hadDealPager.pageNumber = val;
                this.getPageInfo(this.hadDealPager,3);//页面初始化时渲染第一页我的已办
            },
            handleMessageCurChange(val) {
                this.messagePager.pageNumber = val;
                this.getPageInfo(this.messagePager,1);//页面初始化时渲染第一页我的消息
            },
            download(){
                let that = this;
                this.$root.postHttp('/v1/formflow/getSAttachment',{
                    "relatedId": this.currentLi.subRelatedId
                },function (res) {
                    let url = that.$root.baseUrl+'/v1/public/download/download_direct?attachmentPath='+res.data.data.attachPath+'&attachmentName='+encodeURIComponent(res.data.data.attachName);
                    window.location.href= url;
                })
            },
            showDialog(val){
                this.currentLi.msgType = val.msgType;
                this.currentLi.subRelatedId = val.subRelatedId;
                if(val.jumpFlag == 1){
                    this.$router.push('/master/basicInfo');
                    window.sessionStorage.setItem('activeNum','3');
                } else {
                    this.dialogTitle = val.msgTitle;
                    this.dialogContent = val.msgContent;
                    this.dialogVisible = true;
                }
                this.$root.getHttp('/v1/sMessages/readSMessage/'+ val.id,function(res){
                    val.readFlag = 1;//1已读， 0 未读
                })
            }
        }
    }
</script>
<style lang="scss">
    @import "../../assets/var";
    #masterMore {
        background: #fff;
        .head-top {
            background: #fff;
        }
        .mainCon {
            margin-top: 100px;
            .el-tabs {
                width: 1100px;
                margin: 0 auto;
                background: #fff;
                /*padding-top: 20px;*/
                & .el-tabs__header {
                    margin: 0 0 10px;
                }
                & .el-tabs__nav {
                    margin-left: 40px;
                }
                & .el-tabs__item {
                    font-size: 14px;
                    height: 50px;
                }
                & .el-tabs__item.is-active {
                    color: $--text-color;
                    font-weight: 700;
                }
                & .el-tabs__active-bar {
                    bottom: -2px;
                    height: 12px;
                    background: url('../../assets/images/register/at.png') no-repeat center 0;
                }
                & .el-tabs__nav-wrap::after {
                    height: 1px;
                    background-color: $--secondary-fill-color;
                }
            }
        }
        .el-tabs__header {
            margin: 0;
        }
        & .needDeal {
            padding: 20px 50px 50px;
            box-sizing: border-box;
            background: #fff;
            & h3 {
                overflow: hidden;
                & img {
                    float: left;
                    width: 224px;
                    height: 30px;
                }
            }
            & .needList {
                margin-top: 15px;
                & li {
                    padding: 26px 0;
                    border-bottom: 1px solid $--secondary-fill-color;
                    & h4 {
                        overflow: hidden;
                        & strong {
                            float: left;
                            max-width: 600px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            font-size: 14px;
                            line-height: 32px;
                        }
                        & .el-button {
                            float: right;
                            padding: 8px 12px;
                        }
                    }
                    & p {
                        padding-left: 28px;
                        text-align: left;
                        font-size: 12px;
                        line-height: 24px;
                        color: $--text-color-lighter;
                        background: url('../../assets/images/masterCenter/icon01.png') no-repeat;
                    }
                }
                & .lastLi {
                    border: none;
                }
            }
        }
        .dealed {
            padding: 20px 50px 50px;
            box-sizing: border-box;
            background: #fff;
            & h3 {
                text-align: left;
                font-size: 18px;
                line-height: 18px;
                padding-bottom: 8px;
                /*border-bottom: 1px solid #ccc;*/
            }
            & h3::before,
            & h3::after {
                vertical-align: middle;
                display: inline-block;
                content: '';
                width: 10px;
                height: 10px;
                background: url('../../assets/images/masterCenter/titBg.png') no-repeat;
            }
            & .line {
                width: 200px;
                height: 1px;
                background: $--secondary-fill-color;
            }
            & .list {
                margin-top: 15px;
            }
            & .list li {
                cursor: pointer;
                text-align: left;
                margin: 30px 0;
                font-weight: 700;
                .infoTitle {
                    padding: 0 44px 0 24px;
                    /*padding-left: 24px;*/
                    background: url('../../assets/images/masterCenter/icon02.png') no-repeat;
                    font-weight: inherit;
                    height: 24px;
                    font-size: 14px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    strong {
                        font-weight: inherit;
                        display: inline-block;
                        vertical-align: top;
                        width: 150px;
                    }
                }
                p {
                    padding-left: 24px;
                    font-size: 12px;
                    line-height: 24px;
                    color: $--text-color-lighter;
                }
            }
            & .list .readed {
                font-weight: normal;
            }
        }
        .needDeal li strong:hover,
        .dealed li strong:hover {
            cursor: pointer;
            color: $--primary-color;
            text-decoration: underline;
        }
        .el-dialog {
            .el-dialog__headerbtn .el-dialog__close {
                padding: 3px;
                border: 1px solid #999;
                border-radius: 50%;
                transform: rotate(0deg);
                transition: .5s transform;
            }
            .el-dialog__headerbtn .el-dialog__close:hover {
                transform: rotate(180deg);
                border-color: #cb1235;
            }
            .el-dialog__title {
                font-size: 16px;
                font-weight: 700;
            }
            .el-dialog__body {
                padding-top: 20px;
            }
            p {
                text-align: left;
                text-indent: 2em;
            }
            p:nth-of-type(1){
                font-weight: bold;
                line-height: 34px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/master/More.vue